var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7L12.3845 4.76892C12.0634 4.1268 11.9029 3.80573 11.6634 3.57116C11.4516 3.36373 11.1963 3.20597 10.9161 3.10931C10.5992 3 10.2402 3 9.52229 3H5.7C4.5799 3 4.01984 3 3.59202 3.21799C3.21569 3.40973 2.90973 3.71569 2.71799 4.09202C2.5 4.51984 2.5 5.0799 2.5 6.2V7M2.5 7H17.7C19.3802 7 20.2202 7 20.862 7.32698C21.4265 7.6146 21.8854 8.07354 22.173 8.63803C22.5 9.27976 22.5 10.1198 22.5 11.8V16.2C22.5 17.8802 22.5 18.7202 22.173 19.362C21.8854 19.9265 21.4265 20.3854 20.862 20.673C20.2202 21 19.3802 21 17.7 21H7.3C5.61984 21 4.77976 21 4.13803 20.673C3.57354 20.3854 3.1146 19.9265 2.82698 19.362C2.5 18.7202 2.5 17.8802 2.5 16.2V7ZM10.6 17.5H14.4C14.9601 17.5 15.2401 17.5 15.454 17.391C15.6422 17.2951 15.7951 17.1422 15.891 16.954C16 16.7401 16 16.4601 16 15.9V15.1C16 14.5399 16 14.2599 15.891 14.046C15.7951 13.8578 15.6422 13.7049 15.454 13.609C15.2401 13.5 14.9601 13.5 14.4 13.5H10.6C10.04 13.5 9.75992 13.5 9.54601 13.609C9.35785 13.7049 9.20487 13.8578 9.10899 14.046C9 14.2599 9 14.5399 9 15.1V15.9C9 16.4601 9 16.7401 9.10899 16.954C9.20487 17.1422 9.35785 17.2951 9.54601 17.391C9.75992 17.5 10.04 17.5 10.6 17.5ZM14.25 13.5V11.75C14.25 10.7835 13.4665 10 12.5 10C11.5335 10 10.75 10.7835 10.75 11.75V13.5H14.25Z",
    stroke: "#043F6C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLock);
export default __webpack_public_path__ + "static/media/ic-lock.6254b99adc22c72d21570438063d3638.svg";
export { ForwardRef as ReactComponent };